import React from "react";
import DevicesOtherOutlinedIcon from "@mui/icons-material/DevicesOtherOutlined";
import { NO_TYPE } from "./selection";

const plural = (count, word, many = `${word}s`) => `${count} ${count === 1 ? word : many}`;

// The store's appliance count under the dashboard's filters: the total, how
// many device types they span, and a chip per device type with its count.
// `groups` are the Device Type dropdown's options (selection.deviceTypeGroups).
// The chips only show counts.
function StoreApplianceSummary({ groups = [] }) {
  if (groups.length === 0) return null;

  const total = groups.reduce((sum, group) => sum + group.devices.length, 0);
  const types = groups.filter((group) => group.key !== NO_TYPE).length;

  return (
    <section className="dash-count" aria-label="Store appliances">
      <div className="dash-count-total">
        <span className="dash-count-icon" aria-hidden="true">
          <DevicesOtherOutlinedIcon />
        </span>
        <div>
          <div className="dash-count-label">Appliances in this store</div>
          <div className="dash-count-value">{total}</div>
          <div className="dash-count-sub">{plural(types, "device type")}</div>
        </div>
      </div>

      <ul className="dash-count-types" aria-label="Appliances by device type">
        {groups.map((group) => {
          return (
            <li
              key={group.key}
              className={
                group.key === NO_TYPE ? "dash-count-chip dash-count-chip-unset" : "dash-count-chip"
              }
            >
              <span className="dash-count-chip-name" title={group.label}>
                {group.label}
              </span>
              <span className="dash-count-chip-count">{group.devices.length}</span>
            </li>
          );
        })}
      </ul>
    </section>
  );
}

export default StoreApplianceSummary;
